import clsx from 'clsx';
import { NewButton } from '../../../ui/NewButton/NewButton';
import styles from '../PdfRenderer.module.scss';

interface WordToolbarProps {
    textMode: boolean;
    onToggleText: () => void;
}

export function WordToolbar({ textMode, onToggleText }: WordToolbarProps) {
    return (
        <div className={styles.toolbarGroup}>
            <NewButton
                icon={textMode ? 'fa-solid fa-xmark' : 'fa-solid fa-highlighter'}
                onClick={onToggleText}
                className={clsx(styles.toolbarIconBtn, textMode && styles['toolbarIconBtn--active'])}
                tooltip={textMode ? 'Выделите текст…' : 'Аннотация'}
                aria-label="Аннотация"
            />
        </div>
    );
}
